import * as yup from 'yup';

export interface TotalTax {
    taxNumber: number,
    taxTotal: number
}

export interface TenantPdfData {
    logo: string,
    tenantName: string,
    tenantCountry: string,
    tenantAbbreviation: string,
    responsiblePersonName: string,
    responsiblePersonAbbreviation: string,
    mainAddress: string,
    mainZipCode: string,
    mainCity: string,
    mainCountry: string,
    offererAdress: string,
    offererZipCode: string,
    offererCity: string,
    offererCountry: string,
    telephoneNumber: string,
    web: string,
    email: string,
    registerNumber: string,
    taxNumber: string,
    vatNumber: string,
    ceo: string,
    bankName: string,
    iban: string,
    swift: string,
    paymentBankName?: string | null,
    paymentIban?: string | null,
    paymentAccountNumber?: string | null,
    paymentSwift?: string | null,
    dateFormat?: string | null,
    termsAndConditionsURL?: string | null,
}

export interface RecipientPdfData {
    recipientName: string,
    recipientNameExtension?: string | null,
    recepientAbbreviation: string,
    hasResponsiblePerson: boolean,
    responsiblePersonName: string | null,
    responsiblePersonFirstName: string | null,
    responsiblePersonLastName: string | null,
    responsiblePersonAbbreviation: string,
    responsiblePersonGender: string | null,
    responsiblePersonSuffixTitles: string[] | null,
    address: string,
    zipCode: string,
    city: string,
    country: string,
    registerNumber: string,
    taxNumber: string,
    vatNumber: string,
}

export interface GetPdfDataRequest {
    projectId?: string | null,
    tenantId: string,
    tenantLocationId: string,
    tenantResposiblePersonId: string,
    recipientId: string,
    recipientLocationId: string,
    recipientResponsiblePersonId: string | null,
    tenantBankDataId?: string | null
}

export interface PdfDataResponse {
    tenantData: TenantPdfData,
    recipientData: RecipientPdfData,
    isCostCenter: boolean
}


export interface AdditionalPdfDataModel {
    additionalCurrency?: string | null,
    exchangeRate?: number | null,
    language: string | null,
    additionalLanguage?: string | null,
    showArticle: boolean,
    showWage: boolean,
    showMaterial: boolean
}

export interface PdfSettingRequest {
    id: string,
    documentTypeId: string,
    additionalCurrency: string | null,
    language: string | null,
    additionalLanguage: string | null,
    showArticle: boolean,
    showWage: boolean,
    showMaterial: boolean
}

export interface PdfSettingResponse {
    message: string,
}

export const AdditionalPdfDataModelInit: AdditionalPdfDataModel = {
    additionalCurrency: null,
    exchangeRate: null,
    language: null,
    additionalLanguage: null,
    showArticle: false,
    showWage: false,
    showMaterial: false,
}

export const AdditionalPdfDataModelScheme = yup.object().shape({
    additionalCurrency: yup.string().nullable(),
    exchangeRate: yup.number().min(0.1, 'The exchange rate must be a positive number greater than or equal to 0.1.').when('additionalCurrency', {
        is: null,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required("Exchange rate is required."),
    }).nullable(),
    language: yup.string().required('Language is required field.').nullable(),
    additionalLanguage: yup.string().nullable(),
    showArticle: yup.boolean().defined(),
    showWage: yup.boolean().defined(),
    showMaterial: yup.boolean().defined()
});